export default __webpack_public_path__ + "static/media/blog-img67.ce201d61.jpg";